
export { HomeModule, HomeWithRouteModule } from './home.module';
